import React from "react";

const About = () => {
  return (
    <div
      name="about"
      className="w-full md:h-screen bg-gradient-to-b from-gray-800 to-black text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            About
          </p>
        </div>
        <p className="text-xl md:mt-20">
          
I am a skilled MERN stack developer with expertise in front-end and back-end development. 
Proficient in MongoDB, Express.js, React.js, and Node.js, I create dynamic and user-friendly web applications. Additionally, I am well-versed in integrating Amazon S3 buckets and other cloud technologies to ensure efficient data management and security.
Beyond my professional work, I am passionate about continuous learning and regularly undertake personal projects. Notably, I have developed a sophisticated Face Attendance System using Python, employing facial recognition technology for real-time attendance tracking.
I have also explored Augmented Reality (AR) in Unity, creating an interactive food menu application to enhance the dining experience.


        <br />

        <p className="text-xl pt-4">
        My problem-solving skills are a fundamental aspect of my work ethic. 
        I approach challenges with an analytical mindset and relentless determination to find optimal solutions.
I am enthusiastic about collaborating with like-minded individuals to push the boundaries of technology and innovation. 
My diverse skill set, dedication to growth, and problem-solving abilities make me a valuable asset to any team or project. Let's create something remarkable together!
        </p>
        </p>
      </div>
    </div>
  );
};

export default About;
